import React from "react";
import {BrowserRouter, Switch, Route} from "react-router-dom";
import DogProfile from "../pages/DogProfile";
import Filters from "../pages/Filters";
import Results from "../pages/Results";
import NotFound from "../pages/NotFound";
import Home from "../pages/Home";
import { SEARCH, SEE_RESULTS, DOG_PROFILE, DIRECTORY } from "../constants/routesPaths";
import Directory from "../pages/Directory";

function App() {
    return(
        <BrowserRouter>
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path={SEARCH} component={Filters} />
                <Route exact path={SEE_RESULTS} component={Results} />
                <Route exact path={`${DOG_PROFILE}:id/`} component={DogProfile} />
                <Route exact path={DIRECTORY} component={Directory} />
                <Route path="*" component={NotFound} />
                {/* <Route exact path="/404" component={NotFound} />
                <Redirect from="*" to="/404" /> */}
            </Switch>
        </BrowserRouter>
    );
}

export default App;